"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _themeUi = require("theme-ui");

var _useCustomValidity = require("../hooks/useCustomValidity");

var _useMergedRef = require("../hooks/useMergedRef");

var _useOnFocusReportValidity = require("../hooks/useOnFocusReportValidity");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var withValidation = function withValidation(WrappedComponent) {
  var WithValidation = (0, _react.forwardRef)(function (_ref, ref) {
    var id = _ref.id,
        name = _ref.name,
        validationMessage = _ref.validationMessage,
        props = _objectWithoutPropertiesLoose(_ref, ["id", "name", "validationMessage"]);

    WrappedComponent.displayName = "WithValidation(" + getDisplayName(WrappedComponent) + ")";
    var fieldRef = (0, _useMergedRef.useMergedRef)([ref]);
    (0, _useCustomValidity.useCustomValidity)(fieldRef, validationMessage);
    (0, _useOnFocusReportValidity.useOnFocusReportValidity)(fieldRef);
    return (0, _themeUi.jsx)(WrappedComponent, _extends({
      "aria-invalid": !!validationMessage,
      id: id,
      name: name || id
    }, props, {
      ref: fieldRef
    }));
  });
  WithValidation.displayName = 'WithValidation';
  WithValidation.propTypes = {
    id: _propTypes["default"].string.isRequired,
    name: _propTypes["default"].string,
    validationMessage: _propTypes["default"].string
  };
  return WithValidation;
};

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var _default = withValidation;
exports["default"] = _default;